import React from 'react';

import Context     from '../../../../../../context';
import validations from '../../../../../../validations';

import { useFormik         } from 'formik';
import { useTranslation    } from 'react-i18next';
import { locationNamespace } from '../../../../../../types/location.namespace';

import {
  CustomIcon,
  CustomInput,
  CustomModal,
  CustomButton2,
  CustomLeaflet,
  ResponsiveView,
  LocationDropdowns,
} from '../../../../../../components';

import './index.sass';

const Create: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [location, setLocation] = React.useState<Array<number | undefined>>([]);
  const [selectedArea, setSelectedArea] = React.useState<locationNamespace.area.index>();
  const [selectedCity, setSelectedCity] = React.useState<locationNamespace.city.index>();
  const [selectedProvince, setSelectedProvince] = React.useState<locationNamespace.province.index>();
  const [errors, setErrors] = React.useState<any>(undefined);
  const { showModal, setShowModal, createFunction, isLoading } = React.useContext(Context.Location.Neighborhood);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const formik = useFormik<locationNamespace.neighborhood.create>({
    enableReinitialize: true,
    initialValues: {
      isCapital: false,

      key        : undefined,
      name       : '',
      prefix     : undefined,
      description: undefined,

      city     : undefined,
      province : undefined,

      code      : undefined,
      population: undefined,

      // location: {
      //   type: 'Point',
      //   coordinates: [NaN, NaN],
      // }
    },
    validationSchema: validations.location.province.create,
    onSubmit: (values: locationNamespace.neighborhood.create, { setSubmitting }) => {
      if (!selectedArea) return setErrors({area: 'اتنخاب محله اجباری است.'});
      const newValues: locationNamespace.neighborhood.create = {
        ...values,
        town     : selectedArea._id,
        // location: {
        //   type: 'Point',
        //   coordinates: [
        //     location[0] ? Number(location[0]) : Number(selectedArea?.location?.coordinates[0]),
        //     location[1] ? Number(location[1]) : Number(selectedArea?.location?.coordinates[1]),
        //   ]
        // }
      }
      Promise.resolve(createFunction!(newValues)).catch(() => setSubmitting(false));
    },
  });

  async function submitHandler(): Promise<void> {
    await formik.submitForm();
  }

  function handleChangeLocation(lat: any, lng: any): void {
    setLocation([lat, lng]);
  }

  function onSelectProvince(province: locationNamespace.province.index): void {
    setSelectedProvince(province);
    setErrors({province: undefined});
    setLocation([
      province?.location?.coordinates[0] || undefined,
      province?.location?.coordinates[1] || undefined,
    ])
  }

  function onSelectCity(city: locationNamespace.city.index): void {
    setSelectedCity(city);
    setErrors({city: undefined});
    setLocation([
      city?.location?.coordinates[0] || undefined,
      city?.location?.coordinates[1] || undefined,
    ])
  }

  function onSelectArea(area: locationNamespace.area.index): void {
    setSelectedArea(area);
    setErrors({area: undefined});
    setLocation([
      area?.location?.coordinates[0] || undefined,
      area?.location?.coordinates[1] || undefined,
    ])
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="parent-create-modal-container">
      <CustomIcon
        icon="fa-sharp fa-solid fa-circle-plus"
        size="medium"
        hoverTitle={'ساخت محله'}
        onClick={() => {setShowModal!("CREATE")}}
      />
      <form onSubmit={submitHandler}>
        <CustomModal label='ساخت محله' open={showModal === "CREATE"} onClose={() => setShowModal!("NONE")}>
          <ResponsiveView.Container className="create-form-content">
            <br/>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.Province
                  onSelectItem = { onSelectProvince }
                  defaultItem  = { selectedProvince }
                  errorText    = { errors?.province }
                  isError      = { errors?.province }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.City
                  selectedProvince= { selectedProvince }
                  onSelectItem    = { onSelectCity     }
                  defaultItem     = { selectedCity     }
                  errorText       = { errors?.city     }
                  isError         = { errors?.city     }
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.Area
                  selectedProvince = { selectedProvince }
                  selectedCity     = { selectedCity     }
                  onSelectItem     = { onSelectArea     }
                  defaultItem      = { selectedArea     }
                  errorText        = { errors?.area     }
                  isError          = { errors?.area     }
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id            = 'name'
                  name          = 'name'
                  label         = 'نام محله'
                  value         = { formik.values.name }
                  error         = { formik.errors.name && formik.touched.name }
                  errorText     = { formik.errors.name }
                  formikProps   = { {onBlur: formik.handleBlur} }
                  onValueChange = { formik.handleChange }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                {/*<CustomCheckbox label='مرگز استان میباشد'/>*/}
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br/>
            <ResponsiveView.Row className='form-row'>
              <ResponsiveView.Column small={12}>
                <CustomLeaflet
                  onChangeLatAndLng={handleChangeLocation}
                  defaultLat={location[0]}
                  defaultLng={location[1]}
                  defaultLatArea={location[0] ? location[0] : selectedArea?.location?.coordinates[0]}
                  defaultLngArea={location[1] ? location[1] : selectedArea?.location?.coordinates[1]}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br />
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal!("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t("submit")}/>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
          </ResponsiveView.Container>
        </CustomModal>
      </form>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Create;
